import React from 'react';

import { Box, Grid } from '@mui/material';

// Components
import AuditDevices from 'pages/admin/audit/AuditDevices';
import Incidentals from 'components/admin/incidentals/Incidentals';

export default function AuditEventEditor(props) {
    const { event, onUpdate, onClose } = props;

    // Responsive padding (p=[2,4]) does not work if it's the root component
    // Something to look into when there's time
    return (
        <Box>
            <Box p={[2, 4]}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6} lg={3}>
                        <AuditDevices
                            eventId={event.eventId}
                            onUpdate={onUpdate}
                            onClose={onClose}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={9}>
                        <Incidentals
                            eventId={event.eventId}
                            onUpdate={onUpdate}
                            limitTypes={[2, 3, 999]} // Only show specific incidental types
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
